import { createContext } from 'react';

const AuthContext = createContext(null) as any;

export default AuthContext;